<template>
  <div class="footer-info">
    <!--© 2010-{{nowYear}} 生意专家 ™-->
    <img src="../../assets/images/footer/brand.png" alt="">
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default {
    data () {
      return {}
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {},
    computed: {
      nowYear () {
        return new Date().getFullYear()
      }
    },
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?5e487810